'use client';

import type { MapDownloadContent, MapDownloadPlacement } from '@repo/types/analytic-events/maps-analytic-events';
import {
    appendMapDownloadAttribution,
    appendMapDownloadContext,
    type MapDownloadAttribution,
} from '@repo/utility/download-attribution';
import { useEffect, useMemo, useState } from 'react';

export function useMapDownloadPath(
    placement: MapDownloadPlacement,
    context: Pick<MapDownloadAttribution, 'mapId' | 'titleId'> = {},
    basePath = '/download',
    utmContent?: MapDownloadContent,
): string {
    const [acquisitionId, setAcquisitionId] = useState<string | null>(null);
    const { mapId, titleId } = context;
    const contextPath = useMemo(
        () => appendMapDownloadContext(basePath, { mapId, titleId }),
        [basePath, mapId, titleId],
    );

    useEffect(() => setAcquisitionId(crypto.randomUUID()), []);

    return useMemo(() => {
        if (!acquisitionId) return contextPath;

        return appendMapDownloadAttribution(basePath, {
            acquisitionId,
            placement,
            utmContent,
            mapId,
            titleId,
            pagePath: window.location.pathname,
        });
    }, [acquisitionId, basePath, contextPath, mapId, placement, titleId, utmContent]);
}
